// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={222}
        height={136}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        viewBox='0 0 222 136'
        {...props}
    >
        <rect
            width='63'
            height='52'
            rx='3.01587'
            transform='matrix(1 0 0 -1 19 99)'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            width='63'
            height='52'
            rx='3.01587'
            transform='matrix(1 0 0 -1 139 128)'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M12 25.2963L12 39L167 39'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <ellipse
            cx='2'
            cy='2'
            rx='2'
            ry='2'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 10 25)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <path
            d='M211.75 115.232L211.75 90.9336L187.902 90.9336'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='211.75'
            cy='117.482'
            r='2.24985'
            transform='rotate(180 211.75 117.482)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <rect
            x='37.6801'
            y='17.5485'
            width='149.372'
            height='97.7757'
            rx='5.41732'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='5.41732'
        />
        <g clipPath='url(#clip0_3901_6613)'>
            <rect
                width='137.691'
                height='85.4942'
                transform='translate(43.5203 23.8399)'
                fill='var(--center-channel-bg)'
            />
            <rect
                x='43.5203'
                y='23.8399'
                width='45.6761'
                height='98.3792'
                fill='var(--indigo-400)'
                fillOpacity='0.16'
            />
            <path
                d='M59.3313 30.867L76.0206 30.867'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M59.3313 33.5021L68.9935 33.5021'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M94.4666 31.3063H115.548'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M47.9124 42.2861H61.0881'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='51.0298'
                cy='31.3494'
                r='4.34771'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='48.9995'
                cy='47.0006'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M54.939 47.0006H79.5338'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='104'
                cy='45.0007'
                r='5'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M112 45.0007H165.056'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M112 49.0007H165.056'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M112 41.0007H125.176'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='104'
                cy='64.0005'
                r='5'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M112 64.0005H165.056'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M112 68.0005H165.056'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M112 60.0005H125.176'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='104'
                cy='83.0003'
                r='5'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M112 83.0003H165.056'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M112 87.0003H165.056'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M112 79.0003H125.176'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='48.9995'
                cy='54.0008'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M54.939 54.0008H74.2635'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='48.9995'
                cy='62.0004'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M54.939 62.0004H82.1689'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='48.9995'
                cy='69.0005'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M54.939 69.0005H79.5338'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='48.9995'
                cy='76.0006'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M54.939 76.0006H74.2635'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='48.9995'
                cy='83.0007'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M54.939 83.0007H82.1689'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
        </g>
        <path
            d='M186.675 0.5C187.746 0.500207 188.676 1.29454 189.323 2.55859L211.3 45.582L211.419 45.8252C211.981 47.0388 211.985 48.2242 211.403 49.1445C210.786 50.1214 209.598 50.6543 208.117 50.6543H165.206C163.733 50.6542 162.554 50.1221 161.938 49.1465C161.321 48.1678 161.361 46.8865 162.021 45.5869L162.022 45.5859L184.007 2.55859L184.009 2.55469C184.669 1.29203 185.605 0.5 186.675 0.5Z'
            fill='var(--yellow-400)'
            stroke='var(--center-channel-color)'
        />
        <path
            d='M193.19 3.52893L195.802 8.58678M213 41.8843L207.993 32.1901L206.687 29.6612L204.946 26.2893L202.551 21.6529M200.809 18.281L197.544 11.9587'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M183.213 18.7002L185.473 33.8262C185.495 34.1264 185.63 34.4072 185.851 34.6121C186.072 34.8171 186.363 34.9311 186.665 34.9311C186.967 34.9311 187.258 34.8171 187.479 34.6121C187.7 34.4072 187.835 34.1264 187.857 33.8262L190.116 18.7002C190.527 12.8024 182.796 12.8024 183.213 18.7002Z'
            fill='var(--neutral-900)'
        />
        <path
            d='M186.662 36.5614C187.347 36.5626 188.015 36.7659 188.583 37.1455C189.152 37.5251 189.594 38.0641 189.855 38.6943C190.116 39.3244 190.184 40.0176 190.05 40.686C189.915 41.3545 189.585 41.9683 189.101 42.4499C188.617 42.9315 188 43.2593 187.329 43.3919C186.658 43.5244 185.962 43.4558 185.33 43.1946C184.698 42.9334 184.158 42.4915 183.778 41.9246C183.398 41.3577 183.195 40.6912 183.195 40.0095C183.195 39.5562 183.285 39.1073 183.459 38.6885C183.634 38.2698 183.889 37.8894 184.211 37.5691C184.533 37.2488 184.915 36.995 185.336 36.8221C185.757 36.6491 186.207 36.5606 186.662 36.5614Z'
            fill='var(--neutral-900)'
        />
        <path
            d='M192.347 53.6859H209.207'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <defs>
            <clipPath id='clip0_3901_6613'>
                <rect
                    width='137.691'
                    height='85.4942'
                    fill='white'
                    transform='translate(43.5203 23.8399)'
                />
            </clipPath>
        </defs>
    </svg>
);

export default SvgComponent;
